angular.module('cvsApp').service('getUserChallengeQuestionsService', [
  'networkService',
  'configManager',
  'getChallengeQuestionsModel',
  function(NS, CM, GCQM) {
    function getUserChallengeQuestionsService() {
      this.getChallengeQuestionsdata = function(callBackSuccess) {
        //get url
        var url = CM.getAPIUrlWithOtherInfo('GET_USER_CHALLENGE_QUESTIONS', cvsUtility.queryMap.tokenId, 'Login');
		url = removeURLParameter(url, 'serviceCors');
		var plainUrl = CM.getPlainApiUrl(url);
        var request = {
          url: plainUrl,
          header: { 'Content-Type': 'application/json', Accept: 'application/xml' },
          data: getRequestBody(url),
          onSuccess: callBackSuccess
        };
        cvsUtility.commonServiceCode(plainUrl, 'getChallengeQuestions', GCQM, request, callBackSuccess, NS);
	  };
	  
	  
      var getRequestBody = function(entities) {
		var requestJson = { serviceParams: CM.getModifiedParams(entities) };
        return requestJson;
      };
    }

    return new getUserChallengeQuestionsService();
  }
]);
